import React from "react";
import { Box, Grid, Typography, Button, Alert } from "@mui/material";
import MonetizationOnOutlined from "@mui/icons-material/MonetizationOnOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";
import FormDrawer from "components/Shared/FormDrawer";
import { useEntityDetailContext } from "contexts/EntityDetailContext";
import {
    useCreateServiceChargeMutation,
    useUpdateServiceChargeMutation
} from "store/services/entityApi";
import { toast } from "react-toastify";
import ServiceChargeForm from "./ServiceChargeForm";

const ServiceChargeTab = () => {
    const { entityDetail, loadingEntity } = useEntityDetailContext();
    const [showForm, setShowForm] = React.useState(false);

    const serviceCharge = entityDetail?.serviceCharge || null;

    const [createCharge, { isLoading: creating }] =
        useCreateServiceChargeMutation();

    const [updateCharge, { isLoading: updating }] =
        useUpdateServiceChargeMutation();

    const handleSubmit = async (payload) => {
        try {
            if (serviceCharge) {
                await updateCharge({
                    entityId: entityDetail._id,
                    serviceAmount: payload.serviceAmount,
                    isActive: payload.isActive,
                }).unwrap();

                toast.success("Service charge updated successfully!");
            } else {
                await createCharge({
                    entityId: entityDetail._id,
                    serviceAmount: payload.serviceAmount,
                    isActive: payload.isActive,
                }).unwrap();

                toast.success("Service charge created successfully!");
            }

            setShowForm(false);
        } catch (err) {
            console.error("Service charge error:", err);
            toast.error(err?.data?.message || err?.message || "Operation failed!");
        }
    };

    return (
        <>
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" p={3}>
                <Typography variant="h6">
                    Service Charge Amount
                    <Alert severity="info">
                        This charge is applied only on the COD (Cash on Delivery) amount and is deducted from the total COD before COD Amount transfer to vendor.
                    </Alert>
                </Typography>

                <Button
                    variant="outlined"
                    onClick={() => setShowForm(true)}
                    disabled={loadingEntity}
                >
                    {serviceCharge ? "Update Charge" : "Add Charge"}
                </Button>
            </Box>

            {/* If loading */}
            {loadingEntity ? (
                <Typography px={3}>Loading...</Typography>
            ) : (
                <Box padding={3}>
                    <Grid container spacing={4}>

                        <Grid item xs={12} md={6} lg={4}>
                            <InformationTile
                                icon={() => <MonetizationOnOutlined color="primary" />}
                                title="Service Charge"
                                subtitle={
                                    serviceCharge?.serviceAmount !== undefined &&
                                    serviceCharge?.serviceAmount !== null
                                        ? serviceCharge.serviceAmount.toLocaleString()
                                        : "Not Set"
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4}>
                            <InformationTile
                                icon={() => <InfoOutlined color="primary" />}
                                title="Status"
                            >
                                <Status isActive={serviceCharge?.isActive ?? false} />
                            </InformationTile>
                        </Grid>

                    </Grid>
                </Box>
            )}

            {/* FORM DRAWER */}
            <FormDrawer
                title={serviceCharge ? "Update Service Charge" : "Add Service Charge"}
                open={showForm}
                onClose={() => setShowForm(false)}
            >
                <ServiceChargeForm
                    serviceChargeData={serviceCharge}
                    entityId={entityDetail?._id}
                    isBusy={creating || updating}
                    onCancel={() => setShowForm(false)}
                    onSubmit={handleSubmit}
                />
            </FormDrawer>
        </>
    );
};

export default ServiceChargeTab;